import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';

import { useTranslations } from '../../../../contexts/LocalizationContext';

export const QuickContactUserNickname = () => {
  const translations = useTranslations();
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const trimValue = (event: React.FocusEvent<HTMLInputElement>) => setValue('nickname', event.target.value.trim());

  return (
    <Controller
      control={control}
      name="nickname"
      render={({ field: { value, onChange } }) => (
        <FormControl isInvalid={!!errors.nickname}>
          <FormLabel htmlFor="nickname">{translations('quick_contacts_add_new_contact_nickname')}</FormLabel>
          <Input
            value={value}
            onChange={onChange}
            variant="transparentUnderline"
            my="auto"
            id={'nickname'}
            onBlur={trimValue}
          />
          <FormErrorMessage>{errors.nickname?.message?.toString()}</FormErrorMessage>
        </FormControl>
      )}
    />
  );
};
